var map = {
	"./AboutView": 2217,
	"./AboutView.vue": 2217,
	"./AccountView": 1255,
	"./AccountView.vue": 1255,
	"./BlogView": 6307,
	"./BlogView.vue": 6307,
	"./BoxesView": 8574,
	"./BoxesView.vue": 8574,
	"./CartItemView": 8310,
	"./CartItemView.vue": 8310,
	"./CartView": 400,
	"./CartView.vue": 400,
	"./CheckoutView": 8948,
	"./CheckoutView.vue": 8948,
	"./ContactView": 4072,
	"./ContactView.vue": 4072,
	"./FAQView": 4372,
	"./FAQView.vue": 4372,
	"./HomeView": 6738,
	"./HomeView.vue": 6738,
	"./ItemView": 7184,
	"./ItemView.vue": 7184,
	"./OrderSuccessView": 1850,
	"./OrderSuccessView.vue": 1850,
	"./PersonalizationView": 8083,
	"./PersonalizationView.vue": 8083,
	"./PrivacyPolicyView": 5933,
	"./PrivacyPolicyView.vue": 5933,
	"./SetView": 2919,
	"./SetView.vue": 2919,
	"./ShippingRatesView": 6358,
	"./ShippingRatesView.vue": 6358,
	"./ShopView": 6146,
	"./ShopView.vue": 6146,
	"./TermsConditionsView": 2738,
	"./TermsConditionsView.vue": 2738,
	"./TestPage": 9464,
	"./TestPage.vue": 9464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9596;